var _path;

import * as React from "react";

function SvgClock(props) {
  return /*#__PURE__*/React.createElement("svg", props, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 4C11.161 4 4 11.161 4 20s7.161 16 16 16 16-7.161 16-16S28.839 4 20 4zm13.935 16c0 7.658-6.2 13.935-13.935 13.935-7.658 0-13.935-6.2-13.935-13.935 0-7.658 6.2-13.935 13.935-13.935 7.658 0 13.935 6.2 13.935 13.935zm-9.606 5.697L19.09 21.89a.78.78 0 01-.316-.625V10.968c0-.426.349-.774.774-.774h.904c.425 0 .774.348.774.774v9.439l4.548 3.31c.349.25.42.735.168 1.083l-.53.729a.78.78 0 01-1.083.168z"
  })));
}

export default SvgClock;